export const SERVER_HOST = "https://xn----7sbbald1cjel4a9ai.xn--p1ai" // Production
//export const SERVER_HOST = "http://localhost:8000" // Debug